<template>
  <div :class="['item-box', floor.$row]">
    <div 
      class="item" 
      v-for="(item, index) of floor.iconList"
      :key="item.id"
      @click="onNavigateTo(item, index)"
    >
      <img 
        class="image" 
        :src="item.imgUrl" 
        :style="{ width: width, height: width }"
      />
      <div 
        class="name" 
        :style="{ fontSize: rem2px(floor.fontSize), color: floor.fontColor }"
      >{{item.name}}</div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/common'
import { navigateTo } from '@/views/activities/utils'
export default {
  props: {
    floor: Object,
    home: Object
  },
  created() {
    this.init()
    this.uploadGio()
  },
  methods: {
    rem2px: utils.rem2px,
    /**
     * 使用this.$set会触发watch
     * 所以用if(this.unwatch) this.unwatch() 和
     * this.unwatch = this.$watch('floor', this.init)
     * 包裹代码保证每次执行只触发一次
     */
    init() {
      if(this.unwatch) this.unwatch()
      this.mappingLinkType()
      this.normalizeFloor()
      this.unwatch = this.$watch('floor', this.init)
    },
    normalizeFloor() {
      const s = this.floor.opCategoryStyle
      this.width = utils.rem2px(s ? s.style : 90)
    },
    /**
     * 重新映射一下跳转类型，从而可以调用navigateTo
     */
     mappingLinkType() {
      const linkMap = { 1:51, 3:4, 6:2, 7:6, 8:1, 11:10, 12:14 }
      this.floor.iconList.forEach(item => {
        item.pageLinkType = linkMap[item.linkType]
        item.pageLinkValue = item.linkValue
      })
    },
    onNavigateTo(item, index) {
      this.uploadClickGio(item, index)
      navigateTo(this, item)
    },
    uploadClickGio(item, index) {
      const { home, floor } = this
      const { naid, id } = home.$options

      let type, value;
      switch (floor.goodsLinkType) {
        case 1: // 商品详情页
          type = 3;
          value = item.refId;
          break;
        case 2: // 二级页面
          type = 11;
          value = floor.goodsLinkValue;
          break;
        case 3: // 店铺主页
          type = 4;
          value = item.branchNo;
          break;
        case 4: // 品牌首页
          type = 10;
          value = item.logoId;
          break;
        case 5: // 商品详情落地页
          type = 53;
          value = item.refId;
          break;
        case 6: // 店铺主页落地页
          type = 54;
          value = item.branchNo;
          break;
      }

      const shared = {
        pageType_var: home.$pageName,
        dataSourceType_var: item.goodsLinkType,
        secondPageID_var: home.contentPageId||"",   //ver607埋点:secondPageID_var修改
        dataSourcePageID_var: value,
      };

      switch(home.$from) {
        case 'home':
          gio('track','flowLocationClick',{
            'indexId_var': home.contentPageId,
            'entryType_vara': '运营分类',
            'entryType_floor_var': floor.$index,
            'position_var': item.lineSort,
            'sort_var': '',
            'positionName_var': item.name
          })
          gio('setEvar', 'module_evar', '运营分类')
          break;
        case 'activity':
          gio("track", "activityFlowLocationClick_var", {
            secondPageID_var: `${naid || id}`,
            entryType_vara: "图文导航",
            entryType_floor_var: floor.$index,
            position_var: index,
            sort_var: "",
            shopID_var:"n",   //切换商场ID  ver607 二级页面流量位点击
            belongShop_var:"n",  //归属商场ID
            // belongShop_var:(item&&item.shopId)||"n",  //归属商场ID
            positonName_var: item.name,
            ...shared,  
          })
          break;  
      }
    },
    uploadGio() {
      //ver607  首页曝光
      const { home } = this;
      if(home&&home.$from =="home"){
        gio('track','moduleExposure',{
          pageType_var: home.$pageName,
          indexId_var: this.home.contentPageId,
          entryType_vara: '运营分类',
          entryType_floor_var: this.floor.$index
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.item-box {
  display: flex;
  flex-wrap: wrap;
  font-size: 0;
}
.row-four .item {
  width: 25%;
}
.row-five .item {
  width: 20%;
}
.item-box .item {
  flex-shrink: 0;
  text-align: center;
  margin-top: 20px;
}
.item-box .image {
  display: inline-block;
  object-fit: contain;
}
.item-box .name {
  color: #333333;
  font-size: 22px;
  margin: 6px auto 0 auto;
  line-height: 1.2;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 10px;
}

.row-four .item:nth-child(-n+4),
.row-five .item:nth-child(-n+5) {
  margin-top: 0;
}
</style>
